<script setup>
import { ref, watch, computed, onMounted } from "vue";
import {
  Chart,
  RadarController,
  LineElement,
  PointElement,
  RadialLinearScale,
  //CategoryScale,
  Tooltip,
} from "chart.js";

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
});

// LRR
const chartColors = {
  default: {
    primary: "#00D1B2",
    info: "#209CEE",
    danger: "#FF3860",
  },
};
const labels = props.data.label;
const data = props.data.data;

const datasetObject = (color) => {
  return {
    label: 'Promedio ',
    //fill: false,
    //backgroundColor: chartColors.default[color],
    borderColor: chartColors.default[color],
    //borderWidth: 2,// LRR Es el ancho de la línea que une los puntos
    //borderDash: [],
    //borderDashOffset: 0.0,
    pointBackgroundColor: chartColors.default[color],
    //pointBorderColor: "rgba(255,255,255,0)",
    pointHoverBackgroundColor: chartColors.default[color],
    //pointBorderWidth: 20,// LRR hace el punto más grande
    pointHoverRadius: 4,
    pointHoverBorderWidth: 15,
    pointRadius: 4,
    data: data,// randomChartData(points)
    //tension: 0.5,// LRR quita las líneas que une los puntos
    //cubicInterpolationMode: "default",
  };
};
// Fin LRR

const root = ref(null);

let chart;

Chart.register(
  RadarController,
  LineElement,
  PointElement,
  RadialLinearScale,
  //CategoryScale,
  Tooltip
);

onMounted(() => {
  chart = new Chart(root.value, {
    type: "radar",
    data: { 
      labels,
      datasets: [
        //datasetObject("primary", points),
        datasetObject("info"),
        //datasetObject("danger", points),
        
      ]

    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      scales: { // <-- note change in options from scale to scales
        r: {
          grid: {
            circular: true,
            //display: false// LRR Oculta los círculos
          },
          beginAtZero: true,
          max: 20
        }
      },
      plugins: {
        legend: {
          display: false,
        },
      },
    },
  });
});

const chartData = computed(() => props.data);

watch(chartData, (data) => {
  if (chart) {
    chart.data = data;
    chart.update();
  }
});
</script>

<template>
  <canvas ref="root" />
</template>
